import axios from "axios";

const GetApiResponse = async (
  urls,
  bodyData,
  method,
  userToken,
  flag,
  blobFlag
) => {
  let apiReturn = null;
  let reqType = null;

  if (blobFlag) {
    reqType = "responseType: 'arraybuffer'";
  }
  let dt = bodyData ? bodyData : null;
  let type = flag
    ? "application/vnd.ms-excel"
    : blobFlag
    ? "application/x-pkcs12"
    : "application/json";
  let call = process.env.REACT_APP_API_URL + "/api" + urls;

  try {
    let headers = {
      "Content-Type": type,
      reqType,
    };

    if (userToken) {
      headers.Authorization = `Bearer  ${userToken}`;
    }

    const res = await axios({
      method: method,
      url: call,
      timeout: 30000,
      data: dt,
      headers: headers,
    });

    let resp = "";
    let status = "";
    let code = "";

    if (res.response?.status === 500) {
      resp =
        "A system error occurred while processing your request. Please contact support for further assistance.";
      status = "SERVERERROR";
      code = "SERVERERROR";
    } else if (res.data.returnMessage === "SUCCESS") {
      resp = res.data;
      status = "SUCCESS";
      code = "SUCCESS";
    } else if (res.data.returnMessage === "SERVERERROR") {
      resp = res.data.message;
      status = "SERVERERROR";
      code = "SERVERERROR";
    } else if (res.data.returnMessage === "SEARCHERROR") {
      resp = res.data.message;
      status = "SERVERERROR";
      code = "SEARCHERROR";
    } else if (res.data.returnMessage === "REGISTRATIONERROR") {
      resp = res.data.message;
      status = "SERVERERROR";
      code = "REGISTRATIONERROR";
    } else if (res.data.returnMessage === "VALIDATIONERROR") {
      resp = res.data.message;
      status = "VALIDATIONERROR";
      code = "VALIDATIONERROR";
    } else if (res.status === 200) {
      resp = res.data;
      status = "SUCCESS";
      code = "SUCCESS";
    } else if (res.status === 400) {
      resp = res.data.message;
      status = "SERVERERROR";
      code = "VALIDATIONERROR";
    }

    apiReturn = {
      status: status,
      data: resp,
      code: code,
    };
  } catch (err) {
    let resp = err?.response?.data?.errors;
    let status = "";
    let code = "";

    if (err.code && err.code === "ECONNABORTED") {
      status = "SERVERERROR";
      code = "ECONNABORTED";
    } else if (err?.response?.status === 400) {
      status = "SERVERERROR";
      code = "VALIDATIONERROR";
    } else if (err?.response?.status === 403) {
      status = "SERVERERROR";
      code = "FORBIDDEN";
    } else {
      status = "SERVERERROR";
      code = "SERVERERROR";
    }

    apiReturn = {
      status: status,
      data: resp,
      code: code,
    };
  }

  return apiReturn; // Could be success or error
};

const CallAPI = async (url, bodyData, method, userToken, flag, blobFlag) => {
  const response = await GetApiResponse(
    url,
    bodyData,
    method,
    userToken,
    flag,
    blobFlag
  );
  return response;
};

export default CallAPI;
